import { FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'

import ZoneManagementWrapper from '../pages/layout-builder/ZoneManagementWrapper'
import MRListWrapper from '../pages/layout-builder/MRListWrapper'
import SubmissionWrapper from '../pages/layout-builder/SubmissionDataWrapper'
import MRDetailsWrapper from '../pages/layout-builder/MRDetailsWrapper'
import DashboardWrapper from '../pages/layout-builder/DashboardWrapper'
import AddZoneWrapper from '../pages/layout-builder/AddZoneWrapper'
import DrListWrapper from '../pages/layout-builder/DrListWrapper'
import AddDrWrapper from '../pages/layout-builder/AddDrWrapper'

const PrivateRoutes = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='/*' element={<Navigate to='dashboard' />} />
        <Route path='/dashboard' element={<DashboardWrapper />} />
        <Route
          path='zone_management'
          element={
            <SuspensedView>
              <ZoneManagementWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='doctor_list'
          element={
            <SuspensedView>
              <DrListWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='add_doctor'
          element={
            <SuspensedView>
              <AddDrWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='edit_doctor'
          element={
            <SuspensedView>
              <AddDrWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='mr_list'
          element={
            <SuspensedView>
              <MRListWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='mr_details'
          element={
            <SuspensedView>
              <MRDetailsWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='data'
          element={
            <SuspensedView>
              <SubmissionWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='add_zone'
          element={
            <SuspensedView>
              <AddZoneWrapper />
            </SuspensedView>
          }
        />
        {/* <Route path='/*' element={<Navigate to='admin/error/404' />} /> */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
